import { Fragment, React } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CheckboxField, RadioGroupField, Radio, Flex, TextField, TextAreaField, View, SelectField, Grid } from '@aws-amplify/ui-react';
import { Col, Row } from "react-bootstrap";
import YesNo from '../anamnese_lib/YesNo';
import { DatumToString } from "../../lib/DatumToString";
import StringToDate from "../../lib/StringToDate";
import DatePicker from "react-date-picker";
import { typedReturnValue, handleSimpleDate, handleSimpleDateBlur } from '../anamnese_lib/validateInteger';

const WeitereErkrankungen = (props) => {
    const daten = useSelector(state => state.anamnese.Daten);
    const dispatch = useDispatch();

    const handleChange = (e) => {
        // console.log(e.target)
        const key = e.target.name;
        const val = typedReturnValue(key, e.target.value);
        dispatch({ type: 'anamnese/Modify', payload: { [key]: val } });
        props.handleChange(e);
    }

    const handleCheck = (e) => {
        const key = e.target.name;
        const val = e.target.value === 'on' ? 1 : 0;
        dispatch({ type: 'anamnese/Modify', payload: { [key]: val } });
        props.handleChange(e);
    }

    const handleDate = (e) => {
        // console.log(e);
        const key = e.currentTarget.name;
        const ar = key.split('_');
        const val = DatumToString(e.currentTarget.value);
        const ziel = [...daten[`${ar[0]}_${ar[1]}`]]
        const validated = val === 'NaN.NaN.NaN' ? '' : val;
        ziel[e.currentTarget.index][ar[2]] = validated;
        // console.log(neu)
        // neu[ar[0]][e.currentTarget.index][ar[1]] = val;
        dispatch({ type: 'anamnese/Modify', payload: { [`${ar[0]}_${ar[1]}`]: ziel } });
        props.handleChange({ target: { name: key, value: validated } });
    }

    const handleTextArray = (e) => {
        // console.log(daten)
        const key = e.currentTarget.name;
        const ar = key.split('_');
        const val = e.currentTarget.value;
        const ziel = [...daten[`${ar[0]}_${ar[1]}`]]
        ziel[e.currentTarget.index][ar[2]] = val;
        // console.log(ziel)
        dispatch({ type: 'anamnese/Modify', payload: { [`${ar[0]}_${ar[1]}`]: ziel } });

        props.handleChange({ target: { name: key, value: val } });
    }

    return (
        <>
            <h4>1.3	Weitere Erkrankungen/Operationen/Unfälle</h4>
            <h5>Haben oder hatten Sie schwerwiegende Erkrankungen?</h5>
            <YesNo name="SCHWERWERKRANKUNGEN_YN" value={daten.SCHWERWERKRANKUNGEN_YN} onChange={handleChange} readOnly={props.readOnly} />
            <p></p>
            {daten.SCHWERWERKRANKUNGEN_YN === 1 &&
                <>
                    <Flex
                        direction="row"
                        gap={'1.5rem'}
                        alignItems="center"
                    >
                        <View width="11rem">
                            <b>Diabetes mellitus?</b>
                        </View>
                        <View>
                            <CheckboxField
                                name="DIABMELLITUS_YN"
                                value={daten.DIABMELLITUS_YN === 1 ? "off" : "on"}
                                checked={daten.DIABMELLITUS_YN === 1}
                                onChange={handleCheck}
                                disabled={props.readOnly}
                            />
                        </View>
                        <View >
                            {daten.DIABMELLITUS_YN === 1 &&
                                <TextField
                                    name="DIABMELLITUS_SEIT"
                                    label={'seit: '}
                                    defaultValue={daten.DIABMELLITUS_SEIT}
                                    hasError={props.hasError.DIABMELLITUS_SEIT}
                                    errorMessage="Innerhalb der lezten 100 Jahre!"
                                    onChange={(e) => {handleSimpleDate(e, handleChange, props.hasError, props.setHasError)}}
                                    onBlur={(e) => {handleSimpleDateBlur(e, props.hasError, props.setHasError)}}
                                    direction="row"
                                    placeholder="Jahreszahl?"
                                    alignItems="center"
                                    maxLength={20}
                                    disabled={props.readOnly}
                                />
                            }
                        </View>
                    </Flex>
                    {daten.DIABMELLITUS_YN === 1 &&
                        <>
                            <Flex
                                direction="row"
                                gap={'1.5rem'}
                                alignItems="center"
                            >
                                <View width="3rem"></View>
                                <View width="11rem">
                                    Behandlung mit:
                                </View>

                            </Flex>
                            <Flex
                                direction="row"
                                gap={'1.5rem'}
                                alignItems="center"
                            >
                            <View width="3rem"></View>
                            <RadioGroupField
                                value={daten.DIABMELLITUS_BEH}
                                onChange={handleChange}
                                descriptiveText=""
                                name="DIABMELLITUS_BEH"
                                alignItems="center"
                                direction="row">
                                {['keine Angabe', 'Diät', 'Tabletten'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.DIABMELLITUS_BEH !== (i) ? props.readOnly : false}>{item}</Radio>)}
                            </RadioGroupField>
                            </Flex>
                            <Flex
                                direction="row"
                                gap={'1.5rem'}
                                alignItems="center"
                            >
                            <View width="3rem"></View>
                                Insulin:
                                <YesNo name="DIABMELLITUS_INSULIN_YN" value={daten.DIABMELLITUS_INSULIN_YN} onChange={handleChange} readOnly={props.readOnly} />
                            </Flex>
                            <View >
                                {daten.DIABMELLITUS_INSULIN_YN === 1 &&
                                    <TextField
                                        name="DIABMELLITUS_INSULIN_SEIT"
                                        label={'seit: '}
                                        defaultValue={daten.DIABMELLITUS_INSULIN_SEIT}
                                        hasError={props.hasError.DIABMELLITUS_INSULIN_SEIT}
                                        errorMessage="Innerhalb der lezten 100 Jahre!"
                                        onChange={(e) => {handleSimpleDate(e, handleChange, props.hasError, props.setHasError)}}
                                        onBlur={(e) => {handleSimpleDateBlur(e, props.hasError, props.setHasError)}}
                                        placeholder="Jahreszahl?"
                                        direction="row"
                                        alignItems="center"
                                        maxLength={20}
                                        readOnly={props.readOnly}
                                    />
                                }
                            </View>
                        </>
                    }
                    <p></p>
                    <Flex
                        direction="row"
                        gap={'1.5rem'}
                        alignItems="center"
                    >
                        <View width="11rem">
                            <b>Bluthochdruck?</b>
                        </View>
                        <View>
                            <CheckboxField
                                name="HYPERTONIE_YN"
                                value={daten.HYPERTONIE_YN === 1 ? "off" : "on"}
                                checked={daten.HYPERTONIE_YN === 1}
                                onChange={handleCheck}
                                disabled={props.readOnly}
                            />
                        </View>
                        <View >
                            {daten.HYPERTONIE_YN === 1 &&
                                <TextField
                                    name="HYPERTONIE_SEIT"
                                    label={'seit: '}
                                    defaultValue={daten.HYPERTONIE_SEIT}
                                    hasError={props.hasError.HYPERTONIE_SEIT}
                                    errorMessage="Innerhalb der lezten 100 Jahre!"
                                    onChange={(e) => {handleSimpleDate(e, handleChange, props.hasError, props.setHasError)}}
                                    onBlur={(e) => {handleSimpleDateBlur(e, props.hasError, props.setHasError)}}
                                    placeholder="Jahreszahl?"
                                    direction="row"
                                    alignItems="center"
                                    maxLength={20}
                                    readOnly={props.readOnly}
                                />
                            }
                        </View>
                    </Flex>
                    <p></p>
                    <Flex
                        direction="row"
                        gap={'1.5rem'}
                    >
                        <View width="11rem">
                            <b>Herzkrankheit?</b>
                        </View>
                        <View>
                            <CheckboxField
                                name="KHK_YN"
                                value={daten.KHK_YN === 1 ? "off" : "on"}
                                checked={daten.KHK_YN === 1}
                                onChange={handleCheck}
                                readOnly={props.readOnly}
                            />
                        </View>
                    </Flex>
                    {daten.KHK_YN === 1 &&
                        <>
                            <p></p>
                            <Flex
                                direction="row"
                                gap={'1.5rem'}
                                alignItems="center"
                            >
                                <View width="11rem">
                                </View>
                                <View>
                                    <CheckboxField
                                        name="KHK_RHYTM_YN"
                                        value={daten.KHK_RHYTM_YN === 1 ? "off" : "on"}
                                        checked={daten.KHK_RHYTM_YN === 1}
                                        onChange={handleCheck}
                                        label="Rhytmusstörungen"
                                        disabled={props.readOnly}
                                    />
                                </View>
                                <View >
                                    {daten.KHK_RHYTM_YN === 1 &&
                                        <TextField
                                            name="KHK_RHYTM_SEIT"
                                            label='seit: '
                                            defaultValue={daten.KHK_RHYTM_SEIT}
                                            hasError={props.hasError.KHK_RHYTM_SEIT}
                                            errorMessage="Innerhalb der lezten 100 Jahre!"
                                            onChange={(e) => {handleSimpleDate(e, handleChange, props.hasError, props.setHasError)}}
                                            onBlur={(e) => {handleSimpleDateBlur(e, props.hasError, props.setHasError)}}
                                            placeholder="Jahreszahl?"
                                            direction="row"
                                            alignItems="center"
                                            maxLength={20}
                                            readOnly={props.readOnly}
                                        />
                                    }
                                </View>
                                <p></p>
                            </Flex>
                        </>
                    }
                    {daten.KHK_YN === 1 &&
                        <>
                            <p></p>
                            <Flex
                                direction="row"
                                gap={'1.5rem'}
                                alignItems="center"
                            >
                                <View width="11rem">
                                </View>
                                <View>
                                    <CheckboxField
                                        name="KHK_INFARKT_YN"
                                        value={daten.KHK_INFARKT_YN === 1 ? "off" : "on"}
                                        checked={daten.KHK_INFARKT_YN === 1}
                                        onChange={handleCheck}
                                        label="Herzinfarkt"
                                        disabled={props.readOnly}
                                    />
                                </View>
                                <View >
                                    {daten.KHK_INFARKT_YN === 1 &&
                                        <TextField
                                            name="KHK_INFARKT_AM"
                                            label={'am: '}
                                            defaultValue={daten.KHK_INFARKT_AM}
                                            hasError={props.hasError.KHK_INFARKT_AM}
                                            errorMessage="Innerhalb der lezten 100 Jahre!"
                                            onChange={(e) => {handleSimpleDate(e, handleChange, props.hasError, props.setHasError)}}
                                            onBlur={(e) => {handleSimpleDateBlur(e, props.hasError, props.setHasError)}}
                                            placeholder="Jahreszahl?"
                                            direction="row"
                                            alignItems="center"
                                            maxLength={20}
                                            readOnly={props.readOnly}
                                        />
                                    }
                                </View>
                            </Flex>
                        </>
                    }
                    {daten.KHK_YN === 1 &&
                        <>
                            <p></p>
                            <Flex
                                direction="row"
                                gap={'1.5rem'}
                                alignItems="center"
                            >
                                <View width="11rem">
                                </View>
                                <View>
                                    <CheckboxField
                                        name="KHK_KHK_YN"
                                        value={daten.KHK_KHK_YN === 1 ? "off" : "on"}
                                        checked={daten.KHK_KHK_YN === 1}
                                        onChange={handleCheck}
                                        label="koronare Herzkrankheit"
                                        disabled={props.readOnly}
                                    />
                                </View>
                                <View >
                                    {daten.KHK_KHK_YN === 1 &&
                                        <TextField
                                            name="KHK_KHK_SEIT"
                                            label='seit: '
                                            defaultValue={daten.KHK_KHK_SEIT}
                                            hasError={props.hasError.KHK_KHK_SEIT}
                                            errorMessage="Innerhalb der lezten 100 Jahre!"
                                            onChange={(e) => {handleSimpleDate(e, handleChange, props.hasError, props.setHasError)}}
                                            onBlur={(e) => {handleSimpleDateBlur(e, props.hasError, props.setHasError)}}
                                            placeholder="Jahreszahl?"
                                            direction="row"
                                            alignItems="center"
                                            maxLength={20}
                                            readOnly={props.readOnly}
                                        />
                                    }
                                </View>
                            </Flex>
                        </>
                    }
                    {daten.KHK_YN === 1 &&
                        <>
                            <p></p>
                            <Flex
                                direction="row"
                                gap={'1.5rem'}
                                alignItems="center"
                            >
                                <View width="11rem">
                                </View>
                                <View>
                                    <CheckboxField
                                        name="KHK_SONST_YN"
                                        value={daten.KHK_SONST_YN === 1 ? "off" : "on"}
                                        checked={daten.KHK_SONST_YN === 1}
                                        onChange={handleCheck}
                                        label="andere: "
                                        disabled={props.readOnly}
                                    />
                                </View>
                                <View >
                                    {daten.KHK_SONST_YN === 1 &&
                                        <TextField
                                            name="KHK_SONST"
                                            defaultValue={daten.KHK_SONST}
                                            onChange={handleChange}
                                            direction="row"
                                            label=""
                                            placeholder="welche?"
                                            alignItems="center"
                                            maxLength={128}
                                            readOnly={props.readOnly}
                                        />
                                    }
                                </View>
                                <View >
                                    {daten.KHK_SONST_YN === 1 &&
                                        <TextField
                                            name="KHK_SONST_SEIT"
                                            label={'seit: '}
                                            defaultValue={daten.KHK_SONST_SEIT}
                                            hasError={props.hasError.KHK_SONST_SEIT}
                                            errorMessage="Innerhalb der lezten 100 Jahre!"
                                            onChange={(e) => {handleSimpleDate(e, handleChange, props.hasError, props.setHasError)}}
                                            onBlur={(e) => {handleSimpleDateBlur(e, props.hasError, props.setHasError)}}
                                            placeholder="Jahreszahl?"
                                            direction="row"
                                            alignItems="center"
                                            maxLength={20}
                                            readOnly={props.readOnly}
                                        />
                                    }
                                </View>
                            </Flex>
                        </>
                    }
                    <p></p>
                    <Flex
                        direction="row"
                        gap={'1.5rem'}
                        alignItems="center"
                    >
                        <View width="11rem">
                            erhöhte <b>Blutfettwerte?</b>
                        </View>
                        <View>
                            <CheckboxField
                                name="CHOLESTERIN_YN"
                                value={daten.CHOLESTERIN_YN === 1 ? "off" : "on"}
                                checked={daten.CHOLESTERIN_YN === 1}
                                onChange={handleCheck}
                                disabled={props.readOnly}
                            />
                        </View>
                        <View >
                            {daten.CHOLESTERIN_YN === 1 &&
                                <TextField
                                    name="CHOLESTERIN_SEIT"
                                    label={'seit: '}
                                    defaultValue={daten.CHOLESTERIN_SEIT}
                                    hasError={props.hasError.CHOLESTERIN_SEIT}
                                    errorMessage="Innerhalb der lezten 100 Jahre!"
                                    onChange={(e) => {handleSimpleDate(e, handleChange, props.hasError, props.setHasError)}}
                                    onBlur={(e) => {handleSimpleDateBlur(e, props.hasError, props.setHasError)}}
                                    placeholder="Jahreszahl?"
                                    direction="row"
                                    alignItems="center"
                                    maxLength={20}
                                    readOnly={props.readOnly}
                                />
                            }
                        </View>
                    </Flex>
                </>
            }
            <p></p>
            <h5>Haben Sie andere schwerwiegende Erkrankungen, die Ihnen heute oder in Zukunft Probleme bereiten könnten:</h5>
            <YesNo name="ANDEREKRANKHEITEN_YN" value={daten.ANDEREKRANKHEITEN_YN} onChange={handleChange} readOnly={props.readOnly} />
            {
                daten.ANDEREKRANKHEITEN_YN === 1 &&
                <TextAreaField
                    name="ANDEREKRANKHEITEN"
                    defaultValue={daten.ANDEREKRANKHEITEN}
                    onChange={handleChange}
                    descriptiveText="Welche?"
                    wrap="nowrap"
                    maxLength={256}
                    rows={2}
                    readOnly={props.readOnly}
                />
            }
            <p></p>
            <h5>Erfolgten weitere Operationen außer den bei 1.2 genannten?</h5>
            <YesNo name="WEITERE_OPERATIONEN_YN" value={daten.WEITERE_OPERATIONEN_YN} onChange={handleChange} readOnly={props.readOnly} />
            {
                daten.WEITERE_OPERATIONEN_YN === 1 &&
                <>
                    <Grid
                        columnGap="0.1rem"
                        rowGap="0.1rem"
                        templateColumns="1fr 5fr"
                    >
                        <View>
                            <b>Datum</b>
                        </View>
                        <View>
                            <b>Welche Operation?</b>
                        </View>
                        {(daten.WEITERE_OPERATIONEN).map((element, index) => {
                            // console.log(element, index)
                            return (
                                <Fragment key={"F" + index}>
                                    <Flex alignItems="center" key={"F_WEITERE_OPERATIONEN_DATUM_" + index}
                                    >
                                        <DatePicker
                                            name={"WEITERE_OPERATIONEN_DATUM_" + index}
                                            value={StringToDate(element.DATUM)}
                                            onChange={props.readOnly ? () => { } : (e) => handleDate({ currentTarget: { name: "WEITERE_OPERATIONEN_DATUM", index, value: e } })}
                                            locale="de-DE"
                                            format="dd.MM.y"
                                            maxDate={new Date()}
                                        />
                                    </Flex>
                                    <TextField
                                        key={"WEITERE_OPERATIONEN_ART_" + index}
                                        name={"WEITERE_OPERATIONEN_ART_" + index}
                                        maxLength={128}
                                        defaultValue={element.ART}
                                        onChange={props.readOnly ? () => { } : (e) => handleTextArray({ currentTarget: { name: "WEITERE_OPERATIONEN_ART", index, value: e.target.value } })}
                                        readOnly={props.readOnly}
                                    />
                                </Fragment>
                            )
                        })}
                    </Grid>
                </>
            }
            <p></p>
            <h5>Wie oft fühlten Sie sich im Verlauf der <u>letzten 2 Wochen</u> durch die folgenden Beschwerden beeinträchtigt?</h5>
            <p></p>
            {
                <>
                    <Row>
                        <Col sm={3}>Wenig Interesse oder Freude an Ihren Tätigkeiten</Col>
                        <Col sm={4}>
                            <SelectField
                                label=""
                                value={daten.WENIG_INTERRESSE}
                                onChange={handleChange}
                                descriptiveText=""
                                name="WENIG_INTERRESSE"
                                disabled={props.readOnly}
                            >
                                <option value="0">-- bitte auswählen --</option>
                                <option value="1">überhaupt nicht</option>
                                <option value="2">an einzelnen Tagen</option>
                                <option value="3">an mehr als der Hälfte der Tage</option>
                                <option value="4">beinahe jeden Tag</option>
                            </SelectField>
                        </Col>
                    </Row>
                    <p></p>
                    <Row>
                        <Col sm={3}>Niedergeschlagenheit, Schwermut oder Hoffnungslosigkeit</Col>
                        <Col sm={4}>
                            <SelectField
                                label=""
                                value={daten.NIEDERGESCHLAGENHEIT}
                                onChange={handleChange}
                                descriptiveText=""
                                name="NIEDERGESCHLAGENHEIT"
                                disabled={props.readOnly}
                            >
                                <option value="0">-- bitte auswählen --</option>
                                <option value="1">überhaupt nicht</option>
                                <option value="2">an einzelnen Tagen</option>
                                <option value="3">an mehr als der Hälfte der Tage</option>
                                <option value="4">beinahe jeden Tag</option>
                            </SelectField>
                        </Col>
                    </Row>
                    <p></p>
                    <Row>
                        <Col sm={3}>Nervosität, Ängstlichkeit oder Anspannung</Col>
                        <Col sm={4}>
                            <SelectField
                                label=""
                                value={daten.NERVOSITAET}
                                onChange={handleChange}
                                descriptiveText=""
                                name="NERVOSITAET"
                                disabled={props.readOnly}
                            >
                                <option value="0">-- bitte auswählen --</option>
                                <option value="1">überhaupt nicht</option>
                                <option value="2">an einzelnen Tagen</option>
                                <option value="3">an mehr als der Hälfte der Tage</option>
                                <option value="4">beinahe jeden Tag</option>
                            </SelectField>
                        </Col>
                    </Row>
                    <p></p>
                    <Row>
                        <Col sm={3}>Nicht in der Lage sein, Sorgen zu stoppen oder zu kontrollieren</Col>
                        <Col sm={4}>
                            <SelectField
                                label=""
                                value={daten.SORGEN}
                                onChange={handleChange}
                                descriptiveText=""
                                name="SORGEN"
                                disabled={props.readOnly}
                            >
                                <option value="0">-- bitte auswählen --</option>
                                <option value="1">überhaupt nicht</option>
                                <option value="2">an einzelnen Tagen</option>
                                <option value="3">an mehr als der Hälfte der Tage</option>
                                <option value="4">beinahe jeden Tag</option>
                            </SelectField>
                        </Col>
                    </Row>
                </>
            }
        </>
    )

}

export default WeitereErkrankungen; 